/** Blog 分类：与 PRD 五类集合页一致 */
export const BLOG_CATEGORIES = [
	{
		id: 'account-security',
		slug: 'account-security',
		name: 'Account & Security',
		title: 'GB WhatsApp Account & Security Help | GBWhatPro.org',
		description:
			'Understand GB WhatsApp account restrictions, official app warnings, privacy concerns and APK security risks with practical explanations and safety advice.',
		h1: 'GB WhatsApp Pro Account & Security',
		intro:
			'Third-party WhatsApp modifications sit outside Meta’s official support. That does not mean every warning equals a permanent ban—but it does mean you should read the exact message on your screen and choose a guide that matches your situation, not a generic “download the latest APK” article.',
		icon: 'shield',
		cardText: 'Account bans, official app warnings, privacy and APK safety.',
		guideIndexLead:
			'Five focused guides cover safety basics, ban risk, restriction timers, official-app prompts, and anti-ban claims. Start with the symptom you see today.',
		sections: [
			{
				h2: 'How account restrictions usually appear',
				html: `<p>Restrictions on modified clients often show up as temporary limits, login blocks, countdown timers, or a full-screen message asking you to switch to official WhatsApp. They are not the same as a failed SMS code, a parse error during install, or a crash on launch—those belong under <a href="/blog/troubleshooting/">Troubleshooting</a>.</p>
<p>Before you reinstall or wipe data, note the exact wording, whether you can still open chats, and whether the timer counts down. That detail decides which article below fits.</p>
<ul>
<li><a href="/why-is-gb-whatsapp-account-banned/">Why your GB WhatsApp account was restricted</a> — timers, limits, and what “banned” often means in practice.</li>
<li><a href="/gb-whatsapp-says-use-official-whatsapp/">When GB WhatsApp says use official WhatsApp</a> — login blocks and official-app warnings.</li>
<li><a href="/will-gb-whatsapp-get-you-banned/">Will GB WhatsApp get you banned?</a> — risk factors without scare tactics.</li>
</ul>`,
			},
			{
				h2: 'Safety, privacy, and where you download the APK',
				html: `<p>GB WhatsApp is not distributed through Google Play. The file source, signature, permissions you grant on first launch, and how you update all affect risk. No antivirus badge or “anti-ban” label can guarantee that an unofficial build is safe or that your account will stay active.</p>
<p>Read privacy in practical terms: what the app can access on your phone, whether you trust the site that hosted the APK, and whether you are mixing work accounts with experimental builds.</p>
<ul>
<li><a href="/is-gb-whatsapp-safe/">Is GB WhatsApp safe?</a> — permissions, APK source, and realistic privacy limits.</li>
<li><a href="/does-gb-whatsapp-anti-ban-work/">Does GB WhatsApp anti-ban work?</a> — what anti-ban claims can and cannot do.</li>
</ul>`,
			},
			{
				h2: 'What to do before risky steps',
				html: `<p>If you are about to uninstall, switch to official WhatsApp, or install a new mod version, pause and back up anything you cannot lose. Account guides do not replace backup guides—pair this section with <a href="/blog/backup-migration/">Backup &amp; Migration</a> when you are moving chats or phones.</p>
<ul>
<li>Export or back up chats if your build supports it, before clearing storage.</li>
<li>Do not register a new number repeatedly to bypass a block—it can compound restrictions.</li>
<li>After an official-app warning, forcing the same mod login may not help until the timer or policy clears.</li>
</ul>`,
			},
			{
				h2: 'When to leave this category',
				html: `<p>Verification codes that never arrive, install errors, or message send failures are usually technical—not account-policy—issues. Use <a href="/blog/troubleshooting/">Troubleshooting</a>. Expired-version popups and failed updates are covered under <a href="/blog/updates-compatibility/">Updates &amp; Compatibility</a>.</p>`,
			},
		],
		latestHeading: 'Latest Account & Security Articles',
	},
	{
		id: 'troubleshooting',
		slug: 'troubleshooting',
		name: 'Troubleshooting',
		title: 'GB WhatsApp Troubleshooting and Fixes | GBWhatPro.org',
		description:
			'Troubleshoot common GB WhatsApp problems, including missing verification codes, app crashes, installation errors, failed messages and status download issues.',
		h1: 'GB WhatsApp Pro Troubleshooting',
		intro:
			'Most problems fall into a few buckets: login/SMS, installation, stability (crashes), messaging, or status/media saves. Match the bucket first—then open the guide for that symptom instead of trying random reinstalls.',
		icon: 'wrench',
		cardText: 'Verification codes, crashes, install errors, messaging and status issues.',
		guideIndexLead:
			'Each guide walks through checks in order—from connection and permissions to version conflicts—so you can stop when the symptom is fixed.',
		sections: [
			{
				h2: 'Login and verification codes',
				html: `<p>When SMS or call verification fails, confirm the phone number format, airplane mode, carrier delays, and whether official WhatsApp works on the same SIM. Third-party app warnings during login are account-policy topics—see <a href="/blog/account-security/">Account &amp; Security</a>.</p>
<ul>
<li><a href="/gb-whatsapp-verification-code-not-received/">GB WhatsApp verification code not received</a> — SMS delays, dual-SIM, and retry timing.</li>
</ul>`,
			},
			{
				h2: 'Installation and package errors',
				html: `<p>“App not installed”, parse errors, and conflicts with an existing WhatsApp or GB copy mean different fixes. Identify the exact Android message before deleting folders or downloading another APK from an unknown mirror.</p>
<ul>
<li><a href="/gb-whatsapp-installation-error/">GB WhatsApp installation error</a> — signatures, package conflicts, and storage.</li>
</ul>`,
			},
			{
				h2: 'Crashes and stability',
				html: `<p>Repeated force-closes may involve low memory, corrupted cache, a bad update, or Android version limits. Capture whether the crash happens on open, when opening a specific chat, or after an update—that narrows the checklist.</p>
<ul>
<li><a href="/gb-whatsapp-keeps-crashing/">GB WhatsApp keeps crashing</a> — cache, versions, and device-specific steps.</li>
</ul>`,
			},
			{
				h2: 'Messaging and status saves',
				html: `<p>One tick, no delivery, or pending messages can involve one contact, server status, or account limits—not always “broken internet.” Status download issues are separate from learning how status saving works in settings (<a href="/blog/features-settings/">Features &amp; Settings</a>).</p>
<ul>
<li><a href="/gb-whatsapp-messages-not-sending/">GB WhatsApp messages not sending</a> — connectivity, bans, and per-chat checks.</li>
<li><a href="/gb-whatsapp-status-download-not-working/">GB WhatsApp status download not working</a> — permissions and feature availability.</li>
</ul>`,
			},
			{
				h2: 'After you fix the symptom',
				html: `<p>If troubleshooting started because of an update or “expired version” message, read <a href="/blog/updates-compatibility/">Updates &amp; Compatibility</a> before chasing another APK. If you are moving phones afterward, plan backups under <a href="/blog/backup-migration/">Backup &amp; Migration</a>.</p>`,
			},
		],
		latestHeading: 'Latest Troubleshooting Articles',
	},
	{
		id: 'updates-compatibility',
		slug: 'updates-compatibility',
		name: 'Updates & Compatibility',
		title: 'GB WhatsApp Updates and Compatibility Help | GBWhatPro.org',
		description:
			'Get help with GB WhatsApp update failures, expired versions, Android compatibility and problems that appear after installing an update.',
		h1: 'GB WhatsApp Pro Updates & Compatibility',
		intro:
			'Update problems are not one-size-fits-all: the installer may fail, the app may open but break features, or you may see an expiry screen on an old build. Compatibility with your Android version matters as much as the APK version number.',
		icon: 'refresh',
		cardText: 'Failed updates, expired versions, post-update issues and Android support.',
		guideIndexLead:
			'Four guides split failed installs, expiry messages, post-update bugs, and device support—read the one that matches what changed on your phone.',
		sections: [
			{
				h2: 'When the update itself fails',
				html: `<p>Failed updates often trace to insufficient storage, trying to install over an incompatible package, or a incomplete download. Back up chats when possible before uninstalling—even if the goal is simply to move to a newer GB build.</p>
<ul>
<li><a href="/gb-whatsapp-update-failed/">GB WhatsApp update failed</a> — storage, package names, and clean install paths.</li>
</ul>`,
			},
			{
				h2: 'Expired version and login blocks',
				html: `<p>Expiry screens sometimes mean you are on an old APK, not that your number is permanently banned. Confirm the version you installed and the date of the file before assuming account loss.</p>
<ul>
<li><a href="/gb-whatsapp-expired-version/">GB WhatsApp expired version</a> — expiry messages vs account restrictions.</li>
</ul>`,
			},
			{
				h2: 'Problems after updating',
				html: `<p>If installation succeeded but chats, themes, or privacy settings misbehave, treat it as a regression bug: note what worked before the update, whether clearing cache helps, and whether rolling back is safe for your data.</p>
<ul>
<li><a href="/gb-whatsapp-not-working-after-update/">GB WhatsApp not working after update</a> — post-update checks and rollback cautions.</li>
</ul>`,
			},
			{
				h2: 'Android version and device support',
				html: `<p>Some builds target specific Android API levels or architectures. Older phones may need a different package; emulators and custom ROMs can fail in ways that look like “server down.”</p>
<ul>
<li><a href="/gb-whatsapp-android-compatibility/">GB WhatsApp Android compatibility</a> — versions, RAM, and install requirements.</li>
</ul>`,
			},
			{
				h2: 'Related categories',
				html: `<p>Install errors during update overlap with <a href="/blog/troubleshooting/">Troubleshooting</a>. Official-app or ban timers after updating belong in <a href="/blog/account-security/">Account &amp; Security</a>. Before any uninstall, see <a href="/blog/backup-migration/">Backup &amp; Migration</a>.</p>`,
			},
		],
		latestHeading: 'Latest Update Articles',
	},
	{
		id: 'backup-migration',
		slug: 'backup-migration',
		name: 'Backup & Migration',
		title: 'GB WhatsApp Backup, Restore & Migration Help | GBWhatPro.org',
		description:
			'Learn about GB WhatsApp chat backups, restore problems, phone transfers and the limitations of moving conversations to official WhatsApp.',
		h1: 'GB WhatsApp Pro Backup & Migration',
		intro:
			'Backups in modified WhatsApp clients are not always interchangeable with official WhatsApp or with another phone. Treat backup, restore, and migration as three different tasks—each has its own limits depending on your APK version and Android version.',
		icon: 'backup',
		cardText: 'Backup failures, restore, switching to official WhatsApp, new phone transfer.',
		guideIndexLead:
			'Four guides cover failed backups, restoring chats, switching to official WhatsApp, and moving to a new device—follow them in that order if you are doing a full migration.',
		sections: [
			{
				h2: 'When backup fails or never finishes',
				html: `<p>Backup failures may be caused by low storage, missing Google Drive or local folder permissions, or a build that does not support the backup type you selected. Note whether the failure is immediate or stalls at a percentage.</p>
<ul>
<li><a href="/gb-whatsapp-backup-not-working/">GB WhatsApp backup not working</a> — local vs cloud, permissions, and storage.</li>
</ul>`,
			},
			{
				h2: 'Restoring chats and media',
				html: `<p>Restore usually requires the same app variant and a backup file the app still recognizes. Restoring over existing chats without reading prompts can overwrite data you meant to keep.</p>
<ul>
<li><a href="/restore-gb-whatsapp-chats/">Restore GB WhatsApp chats</a> — matching versions and recovery order.</li>
</ul>`,
			},
			{
				h2: 'Switching to official WhatsApp',
				html: `<p>Moving from GB WhatsApp to official WhatsApp may not transfer all message history, settings, or media—Meta does not support importing unofficial databases. Plan exports and realistic expectations before uninstalling the mod.</p>
<ul>
<li><a href="/switch-from-gb-whatsapp-to-official-whatsapp/">Switch from GB WhatsApp to official WhatsApp</a> — what transfers and what does not.</li>
</ul>`,
			},
			{
				h2: 'New phone and device transfer',
				html: `<p>Phone migration may use local backup files, manufacturer transfer tools, or manual exports—none of which guarantee parity with your old GB install. Back up on the old device before wiping it.</p>
<ul>
<li><a href="/transfer-gb-whatsapp-to-new-phone/">Transfer GB WhatsApp to a new phone</a> — cables, cloud, and verification on the new device.</li>
</ul>`,
			},
			{
				h2: 'Pair with other categories',
				html: `<p>If backup failed because the app crashes or will not open, fix stability under <a href="/blog/troubleshooting/">Troubleshooting</a> first. If you were forced off the mod by a restriction, read <a href="/blog/account-security/">Account &amp; Security</a> before repeated login attempts on a new install.</p>`,
			},
		],
		latestHeading: 'Latest Backup & Migration Articles',
	},
	{
		id: 'features-settings',
		slug: 'features-settings',
		name: 'Features & Settings',
		title: 'GB WhatsApp Features and Settings Help | GBWhatPro.org',
		description:
			'Learn how GB WhatsApp settings work, including message scheduling, chat locks, read receipts, DND mode and status-saving options.',
		h1: 'GB WhatsApp Pro Features & Settings',
		intro:
			'GB WhatsApp adds options that official WhatsApp may not offer, but menus change between releases and forks. These guides explain one feature at a time—where to look in settings, what usually happens, and limits that still apply on your Android version.',
		icon: 'settings',
		cardText: 'Scheduling, chat lock, read receipts, DND mode and status saving.',
		guideIndexLead:
			'Five step-by-step guides cover scheduling, chat lock, hiding read receipts, DND-style quiet modes, and saving status media—pick the feature you are trying to use.',
		sections: [
			{
				h2: 'Privacy and chat controls',
				html: `<p>Read receipts, locks, and hidden chats behave differently from official WhatsApp. A lock may use PIN, pattern, or fingerprint depending on your build; hiding blue ticks does not always hide “online” or typing indicators.</p>
<ul>
<li><a href="/hide-blue-ticks-gb-whatsapp/">Hide blue ticks in GB WhatsApp</a> — read receipts and related privacy options.</li>
<li><a href="/lock-individual-chats-gb-whatsapp/">Lock individual chats in GB WhatsApp</a> — per-chat protection and recovery if you forget the PIN.</li>
</ul>`,
			},
			{
				h2: 'Messaging tools and quiet modes',
				html: `<p>Scheduled messages and DND-style modes may depend on background execution, battery optimizations, and notification permissions. Delivery at an exact minute is not guaranteed if Android kills background tasks.</p>
<ul>
<li><a href="/schedule-messages-gb-whatsapp/">Schedule messages in GB WhatsApp</a> — setting time, recipient, and failed sends.</li>
<li><a href="/use-gb-whatsapp-dnd-mode/">Use GB WhatsApp DND mode</a> — silencing alerts without missing critical calls.</li>
</ul>`,
			},
			{
				h2: 'Status and media',
				html: `<p>Saving status videos or images requires storage permission and a build that still exposes the save action. Respect others’ content—only save media you have rights to store.</p>
<ul>
<li><a href="/download-gb-whatsapp-status-videos/">Download GB WhatsApp status videos</a> — save failures vs missing menu items.</li>
</ul>`,
			},
			{
				h2: 'If a setting “ vanished ” after an update',
				html: `<p>Feature menus move between releases. If something disappeared after an APK update, check <a href="/gb-whatsapp-not-working-after-update/">not working after update</a> and the <a href="/blog/updates-compatibility/">Updates &amp; Compatibility</a> hub before assuming your install is corrupt.</p>`,
			},
			{
				h2: 'Not feature issues?',
				html: `<p>SMS login problems, crashes, or send failures are not settings tutorials—use <a href="/blog/troubleshooting/">Troubleshooting</a>. Account warnings belong in <a href="/blog/account-security/">Account &amp; Security</a>.</p>`,
			},
		],
		latestHeading: 'Latest Features & Settings Articles',
	},
]

export const BLOG_CATEGORY_BY_ID = Object.fromEntries(BLOG_CATEGORIES.map((c) => [c.id, c]))

export function getCategoryBySlug(slug) {
	return BLOG_CATEGORIES.find((c) => c.slug === slug) || null
}

export function categoryPath(slug) {
	return `/blog/${slug}/`
}
